import axios from 'axios'

export default {
  all() {
    return axios
      .get('/api/financial_statements', {
        handleErrors: true
      })
      .then(res => {
        return res.data
      })
  }
}
